import httpClient from "../helpers/httpClient";
import { IChatMessage } from "../interfaces/chat-message.interface";

export const storeChatRequest = (message: string) => {
    return httpClient.post<IChatMessage>("/api/v3/ai/chat", {
        message,
    });
};